import theme from '../../../lib/theme';
import { HolidayBlockProps } from './HolidayBlock';
import { getBlockSpacing } from '../behaviour';

const { layouts, scale, media, colors, font } = theme;

const flexGap = '1rem';

export default ({
  desktop_spacing,
  mobile_spacing,
  background_colour,
  featured_holiday,
  block: { columns_per_row },
}: HolidayBlockProps) => ({
  blockWrap: {
    backgroundColor: background_colour,
    padding: `${getBlockSpacing(mobile_spacing)} 0 ${getBlockSpacing(
      mobile_spacing
    )} 0`,

    [media.s.up]: {
      padding: `${getBlockSpacing(desktop_spacing)} 0 ${getBlockSpacing(
        desktop_spacing
      )} 0`,
    },
  },

  container: {},

  title: {
    margin: `0 !important`,
    padding: `0 !important`,
    fontWeight: '700',
  },

  subtitle: {
    margin: `0 !important`,
    padding: `0 !important`,
    fontWeight: '700',
  },

  holidaysCardsContainer: {
    display: 'flex',
    gap: '1.5em',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },

  holidayCard: {
    display: 'flex',
    flex: `1 1 100% !important`,
    maxWidth: `100% !important`,
    flexDirection: 'column',
    justifyContent: 'space-between',
    border: '1px solid rgba(0,0,0,.125) !important',
    boxShadow: 'none',

    [media.m.up]: {
      flex: `1 1 calc(50% - ${flexGap}) !important`,
      maxWidth: `calc(50% - ${flexGap}) !important`,
    },

    [media.l.up]: {
      flex: `1 1 calc(100% / ${columns_per_row} - ${flexGap}) !important`,
      maxWidth: `calc(100% / ${columns_per_row} - ${flexGap}) !important`,
    },

    [media.l.down]: {
      '&:last-of-type': {
        display: featured_holiday ? 'none !important' : 'flex',
      },
    },
  },

  holidayCardImage: {
    flex: `0 0 auto`,
    padding: 0,
    position: 'relative',

    '> img': {
      width: '100% !important',
      maxWidth: '100% !important',
      height: 'auto !important',
    },
  },

  holidayCardPromoRibbon: {
    position: 'absolute',
    top: '10%',
    left: '-10px',
    backgroundColor: colors.travel360.primary_dark,
    color: colors.white,
    fontWeight: '500',
    padding: '10px',
    boxShadow: '4px 4px 4px rgb(0 0 0 / 40%)',

    '&::before': {
      borderTop: `10px solid ${colors.travel360.primary_dark}`,
      bottom: '-10px',
      borderLeft: '10px solid transparent',
      left: '0',
      content: `''`,
      position: 'absolute',
    },
  },

  holidayTitle: {
    color: colors.black,
    fontWeight: '700',
    fontSize: `${font.m} !important`,
    textDecoration: 'none',
    lineHeight: `${scale.s} !important`,
  },

  featuredHolidayPrice: {
    color: colors.travel360.primary_dark,
    wordWrap: 'normal',
    fontWeight: '700',
    fontSize: '1.4em',
  },

  holidayPrice: {
    color: colors.travel360.primary_dark,
    wordWrap: 'normal',
    fontSize: '1.5em',
    fontWeight: '700',
  },

  holidayContentContainer: {
    padding: `1rem`,
    margin: `0`,
    flex: `1 0 auto`,
    display: 'flex',
    alignItems: 'flex-start',
    fontSize: '0.9em',
    flexDirection: 'column',

    '.flex-row': {
      gap: `${flexGap}`,
    },
  },

  holidayContentHeader: {
    // flex: '0 0 35%',
    gap: `${flexGap}`,
  },

  holidayContent: {},

  holidayContentFooter: {},

  holidayIcon: {
    color: colors.travel360.primary_dark,
    fontSize: font.m,
    paddingLeft: scale.xxxs,
  },

  holidayDaysNights: {
    color: colors.black,
    fontSize: font.m,
  },

  holidayInclusions: {
    ul: {
      listStyle: 'none',
      padding: '0 0 0 4px',

      '> li': {
        paddingLeft: '32px',
        color: colors.black,
        fontSize: font.m,

        '&:before': {
          color: colors.travel360.primary_dark,
          fontSize: font.m,
          left: '4px',
        },
      },
    },
  },

  holidayMoreDetailsButton: {
    //  needs !important to override enclosing a tag
    height: 'auto !important',
    padding: `10px 30px !important`,
    fontSize: `${font.m} !important !important`,
    backgroundColor: '#70ffd7 !important',
    borderColor: '#70ffd7 !important',
    color: `${colors.black} !important`,

    '&:hover': {
      backgroundColor: `${colors.black} !important`,
      color: `${colors.white} !important`,
      borderColor: `${colors.black} !important`,
    },
  },

  featuredHoliday: {
    display: 'flex',
    gap: `${flexGap}`,
  },

  featuredHolidayImageContainer: {
    img: {
      width: '100% !important',
      maxWidth: '100% !important',
      height: 'auto !important',
    },
  },

  featuredHolidayContentContainer: {},

  value_proposition: {
    backgroundColor: 'yellow',
  },
});
